$('.tab-wrapper').each(function () {
  $(this).find('.tab_content').hide();
  $(this).find('.tab_content:first').show();
  $(this).find('.tabs li:first').addClass('active');
});

$('.tabs li').on('click', function (event) {
  $(this).parents('.tab-wrapper').find('.tabs li').removeClass('active');
  $(this).addClass('active');
  $(this).parents('.tab-wrapper').find('.tab_content').hide();
  var selectTab = $(this).attr('data-id');
  $(this).parents('.tab-wrapper').find(selectTab).fadeIn();
});

/** Change field type */
$('.wc-donation-f-donation-other-value').each(function () {
  $(this).attr('type', 'number');
});